import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Basket} from './shopping-cart.service';
import {Observable} from 'rxjs';
import { environment } from '../../environments/environment';
import {Route, Router} from '@angular/router';


@Injectable()
export class PaysonPaymentService {
  constructor(private httpClient: HttpClient,
              private router: Router) {
    console.log('creating payson payment service');
  }

  public sendPaysonPaymentRequest(basket: Basket): Observable<any> {

    // console.log('4 : ' + JSON.stringify(basket));
    basket['route'] = this.router.url;
    return this.httpClient.post(
      environment.payson_basket_checkout,
      JSON.stringify(basket), {observe: 'response'});
  }
}
